import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ClientConfiguration, ClientService, CLIENT_CONFIG } from '../../client.service';
import { schematicMappingMock, schematicMock } from './hydraulic-schematic-mocks';

import { SvgVddMappingResponse } from './hydraulic-schematic.model';

@Injectable()
export class HydraulicSchematicApi {
  baseUrl: string;
  constructor(
    @Inject(CLIENT_CONFIG) private clientConfiguration: ClientConfiguration,
    private clientService: ClientService
  ) {
    this.baseUrl = this.clientConfiguration.baseUrl;
  }

  // returns system hydraulic scheme
  getSchematic(
    deviceId: string,
    hydraulicMatrixCode: string,
    bundleId: string
  ): Observable<string> {
    const endpoint = this.baseUrl + `equipment/v3/devices/${deviceId}/hydraulic-schema`;

    let httpParams = new HttpParams();
    httpParams = httpParams.append('hydramatrixcode', hydraulicMatrixCode);
    httpParams = httpParams.append('bundleId', bundleId);

    return this.clientService.rawGetText<string>(endpoint, httpParams);
  }

  // returns internal hydraulic scheme
  getInternalSchematic(
    deviceId: string,
    hydraulicMatrixCode: string,
    bundleId: string
  ): Observable<string> {
    const endpoint = this.baseUrl + `equipment/v3/devices/${deviceId}/internal-hydraulic-schema`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('hydramatrixcode', hydraulicMatrixCode);
    httpParams = httpParams.append('bundleId', bundleId);

    return this.clientService.rawGetText<string>(endpoint, httpParams);
  }

  getSchematicMapping(deviceId: string): Observable<SvgVddMappingResponse> {
    const endpoint = `equipment/v3/devices/${deviceId}/schemes`;

    return this.clientService.get<SvgVddMappingResponse>(endpoint);
  }

  getSchematicMappingsMock(_deviceId?: string): Observable<SvgVddMappingResponse> {
    return of(schematicMappingMock);
  }

  getSchematicMock(_deviceId?: string, _hydraulicMatrixCode?: string): Observable<string> {
    return of(schematicMock);
  }
}
